<script setup lang="ts">
import type { Category } from '@/types/category';
import Card from './category/Card.vue';

interface Props {
  title?: string;
  categories?: Category[];
}

withDefaults(defineProps<Props>(), {
  title: 'Выберите свое направление',
  categories: () => [],
});
</script>

<template>
  <section id="top-categories" class="w-full py-12 md:py-24">
    <div class="mx-auto max-w-7xl px-4 md:px-6">
      <h2 class="mb-10 text-center text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
        {{ title }}
      </h2>

      <div v-if="categories.length > 0" class="grid gap-6 lg:grid-cols-3 lg:grid-rows-2">
        <Card v-if="categories[0]" :category="categories[0]" variant="large" class="lg:col-span-2 lg:row-span-2" />

        <Card v-for="category in categories.slice(1, 3)" :key="category.id" :category="category" variant="small" />
      </div>
    </div>
  </section>
</template>
